import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useBulkUpdateExecutionDate = () => {
    const queryClient = useQueryClient();
    const intl = useIntl();
    const { mutateAsync, isLoading } = useMutation(items => api.base
        .post(`${config.appUrls.tasks}/api/WeekPlanner/Execution/Bulk`, { items })
        .then(res => res.data), {
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [TaskQueryKey.WeekPlanner] });
            queryClient.invalidateQueries({ queryKey: [TaskQueryKey.WeekPlannerUnplannedTasks] });
        },
        onError: error => {
            handleHttpError(intl)(error);
        },
    });
    return { bulkUpdateExecutionDate: mutateAsync, isLoading };
};
